@if (isLoading()) {
    <p class="text-muted">Loading widgets...</p>
} @else if (groups().length === 0) {
    <p class="text-muted">This user's module access does not include any dashboard widgets.</p>
} @else {
    <div class="widget-admin">
        <nav
            class="area-nav"
            aria-label="Widget business areas"
        >
            @for (group of groups(); track group.businessArea) {
                @let isSelected = group.businessArea === selectedGroup()?.businessArea;
                <button
                    type="button"
                    class="area-nav-item"
                    [style.--ba-bg]="BA_Style[group.businessArea].background"
                    [style.--ba-color]="BA_Style[group.businessArea].color"
                    [style.backgroundColor]="isSelected ? BA_Style[group.businessArea].background : null"
                    [style.color]="isSelected ? BA_Style[group.businessArea].color : null"
                    [attr.aria-current]="isSelected ? 'true' : null"
                    [attr.aria-controls]="group.sectionId"
                    (click)="selectArea(group)"
                >
                    {{ group.name }}
                </button>
            }
        </nav>

        @if (selectedGroup(); as group) {
            <section
                class="area-panel"
                [id]="group.sectionId"
                [attr.aria-labelledby]="group.sectionId + '-heading'"
            >
                <div
                    class="area-panel-head"
                    [style.backgroundColor]="BA_Style[group.businessArea].background"
                    [style.color]="BA_Style[group.businessArea].color"
                >
                    <h5 [id]="group.sectionId + '-heading'">{{ group.name }}</h5>
                    <span class="area-panel-count">{{ group.onDashboardCount }} of {{ group.widgets.length }} on dashboard</span>
                </div>

                <div class="section-ctnr">
                    <div class="widgets">
                        @for (widget of group.widgets; track widget.widgetType) {
                            <button
                                type="button"
                                class="widget"
                                [class.on-dashboard]="widget.isOnDashboard"
                                [class.locked]="isLocked(widget)"
                                [attr.aria-pressed]="widget.isOnDashboard"
                                [attr.aria-disabled]="isLocked(widget) ? 'true' : null"
                                [ngbTooltip]="requiredTooltip(widget)"
                                [disableTooltip]="!requiredTooltip(widget)"
                                container="body"
                                (click)="toggleWidget(widget)"
                            >
                                @if (imageFor(widget.widgetType); as image) {
                                    <span class="widget-image">
                                        <img
                                            [ngSrc]="image.src"
                                            [alt]="image.alt"
                                            fill
                                        />
                                    </span>
                                }

                                <span class="widget-title">
                                    <span class="widget-name">{{ widget.name }}</span>
                                    <span class="widget-badges">
                                        @if (widget.isOnDashboard) {
                                            <span class="widget-status">On dashboard</span>
                                        }
                                        @if (widget.isRequired || isLocked(widget)) {
                                            <span class="widget-required">
                                                <fa-icon
                                                    [icon]="faLock"
                                                    aria-hidden="true"
                                                />
                                                Required
                                            </span>
                                        }
                                    </span>
                                </span>

                                <span class="widget-description">{{ widget.description }}</span>
                            </button>
                        }
                    </div>
                </div>
            </section>
        }
    </div>
}
